export default function(
    userStore,
    postMakerStore,
    newCreationStore,
    postDetailsStore
) {
    const privateChannel = window.Echo.private('App.Models.User.' + userStore.id);

    /**
     * Notifications
     */
    privateChannel
        .notification((notification) => {
            // Post-Connection PublishedMedia
            if(notification.type === 'App\\Notifications\\PostConnectionPublishedNotification') {
                if(notification.details.from === 'postDetails') {
                    // Post Details
                    postDetailsStore.updateConnection(
                        notification.post_id,
                        notification.connection_id,
                        {status: 'published', error: false}
                    );
                } else {
                    // Post Maker
                    if(postMakerStore.currentPostId === notification.post_id) {
                        postMakerStore.selectedConnections[notification.connection_id].status = 'published';
                    }
                }
            }

            // Post-Connection Failed
            if(notification.type === 'App\\Notifications\\PostConnectionFailedNotification') {
                if(notification.details.from === 'postDetails') {
                    // Post Details
                    postDetailsStore.updateConnection(
                        notification.post_id,
                        notification.connection_id,
                        {status: 'failed', error: notification.details}
                    );
                } else {
                    // Post Maker
                    if(postMakerStore.currentPostId === notification.post_id) {
                        postMakerStore.error = true;
                        postMakerStore.selectedConnections[notification.connection_id].status = 'failed';
                        postMakerStore.selectedConnections[notification.connection_id].error = notification.details;
                    }
                }
            }

            if(
                (
                    notification.type === 'App\\Notifications\\PostConnectionPublishedNotification'
                    || notification.type === 'App\\Notifications\\PostConnectionFailedNotification'
                )
                && postMakerStore.currentPostId === notification.post_id
            ) {
                let postingComplete = true;
                let stillAnError = false;
                for(let connectionId in postMakerStore.selectedConnections){
                    if(postMakerStore.selectedConnections[connectionId].status === 'posting') {
                        postingComplete = false;
                    }

                    if(postMakerStore.selectedConnections[connectionId].status === 'failed') {
                        stillAnError = true;
                    }
                }
                if(postingComplete) {
                    postMakerStore.phase = 'complete';
                }
                postMakerStore.error = stillAnError;
            }
        });

    /**
     * Events
     */

    // Creation Media Conversion Complete
    privateChannel
        .listen('CreationMediaConversionCompleteEvent', (e) => {
            let index = newCreationStore.files.findIndex((file) => file.key === e.details.key);
            newCreationStore.files[index].status = 'ready';
            newCreationStore.files[index].conversion_id = e.details.id;
            newCreationStore.files[index].height = e.details.height;
            newCreationStore.files[index].width = e.details.width;
            // LATER: Error handling

            // Check if all ready
            let aU = true;
            newCreationStore.files.forEach((f) => {
                if (f.status !== 'ready') {
                    aU = false;
                }
            });
            newCreationStore.allUploaded = aU;
        });

    // Upload Media Conversion Complete
    privateChannel
        .listen('UploadMediaConversionCompleteEvent', (e) => {
            let attachment = postMakerStore.getAttachment('key', e.details.key);
            if(attachment) { // May have been removed or edited
                attachment.status = 'ready';
                attachment.conversion_id = e.details.id;
                attachment.height = e.details.height;
                attachment.width = e.details.width;
                attachment.thumbnail = e.details.thumbnail;
            }
        });
}
